<template>
  <div class="fccGestaoArquivos">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage titlePage="Branding" />
      <fccTable
        :titlePDF="titlePDF"
        :fields="fieldsBranding"
        :orderby="sortBy"
        :actions="actionsBranding"
        :items="listaImagens"
        :porPage="itemPorPage"
        bordered
        addFilter
        responsive
        search
        pagination
        pdf
      >
        <template #imacaminho="{ row, value }">
          <a :href="value" target="_blank">
            <b-img-lazy :alt="row.imadescricao" :src="value" center fluid />
          </a>
        </template>
      </fccTable>
    </div>

    <fccModal
      :idModal="'modal-edit' + _uid"
      :titleModal="titleModal"
      centered
      trava-esc
      escondeFooter
    >
      <b-form @submit.prevent="EnviarImagem" autocomplete="off">
        <div class="row">
          <div class="col-md-6 mb-3">
            <fcc-input
              extraClasses="inputLabel"
              v-model="imagemForm.imacodigo"
              :disabled="imagemForm.imaid != null"
              required
            >
              Código/Nome arquivo
            </fcc-input>
          </div>

          <div class="col-md-6 mb-3">
            <fcc-input extraClasses="inputLabel" v-model="imagemForm.imaidexterno">
              Id externo
            </fcc-input>
          </div>
        </div>

        <div class="position-relative mb-3">
          <fcc-input extraClasses="inputLabel" v-model="imagemForm.imadescricao" required>
            Descrição
          </fcc-input>
        </div>

        <div class="position-relative mb-3">
          <fcc-input extraClasses="inputLabel" v-model="imagemForm.imametadata">
            Metadado
          </fcc-input>
        </div>

        <b-form-file
          class="my-2"
          placeholder="Escolha ou arraste uma imagem aqui..."
          drop-placeholder="Solte a imagem aqui"
          accept="image/jpeg, image/png, image/gif"
          v-model="fileForm"
          required
        />
        <div class="mt-3 mb-2 text-right">
          <fcc-button type="submit">{{ labelsSystem.salvar }}</fcc-button>
        </div>
      </b-form>
    </fccModal>
  </div>
</template>

<script>
import '@/fccBase.scss'
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      titlePDF: 'Lista identidade visual',
      titleModal: 'Imagem',
      itemPorPage: '25',
      sortBy: 'imacodigo',
      listaImagens: [],
      imagemForm: {},
      fileForm: null,
      fieldsBranding: [
        {
          key: 'imacaminho',
          label: 'Imagem',
          type: 'slot',
          thClass: 'text-center',
          tdClass: 'bg-secondary'
        },
        { key: 'imacodigo', label: 'Código', sortable: true },
        { key: 'imadescricao', label: 'Descrição', sortable: true },
        { key: 'imametadata', label: 'Metadado', sortable: true },
        {
          key: 'actions',
          label: '',
          thClass: 'no-print',
          tdClass: 'no-print text-nowrap'
        }
      ],
      actionsBranding: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },

  methods: {
    addField() {
      this.imagemForm = {
        imacodigo: '',
        imadescricao: '',
        imaativo: true,
        imaidexterno: '',
        imametadata: '',
        imaarqcadcod: null,
        appcodigo: '1'
      }
      this.fileForm = null
      this.$bvModal.show('modal-edit' + this._uid)
    },

    editField(_, item) {
      this.imagemForm = item
      this.fileForm = null
      this.$bvModal.show('modal-edit' + this._uid)
    },

    deleteField(_, item) {
      const url = process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_GESTAO_PROJETOS

      this.callConfirm(this.mensagemExcluir + '?', 'Imagem código: ' + item.imacodigo).then(
        (result) => {
          if (result.value) {
            this.carregaTexto(this.codeMensagem('C02'))

            axios
              .delete(url + 'Imagem/Excluir/' + item.imaid, this.dadosLoginSession.fccTokenHeaders)
              .then(() => {
                this.ListarImagens()
                this.callToast(this.mensagensUpdate.excluido, 'success')
              })
              .catch(this.setErrorSystem)
              .finally(this.carregaTexto)
          }
        }
      )
    },

    EnviarImagem() {
      let request
      let url = process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_GESTAO_PROJETOS
      const formData = new FormData()

      url += this.imagemForm.imaid == null ? 'Imagem/Adicionar?' : 'Imagem/Alterar?'

      for (const key in this.imagemForm) {
        if (Object.hasOwnProperty.call(this.imagemForm, key) && this.imagemForm[key] != null) {
          url += key + '=' + this.imagemForm[key] + '&'
        }
      }

      url = url.substring(0, url.length - 1)

      formData.append('file', this.fileForm, this.imagemForm.imacodigo)

      this.carregaTexto(this.codeMensagem('C03'))

      if (this.imagemForm.imaid == null) {
        request = axios.post(url, formData, {
          headers: {
            ...this.dadosLoginSession.fccTokenHeaders.headers,
            'Content-Type': 'multipart/form-data'
          }
        })
      } else {
        request = axios.put(url, formData, {
          headers: {
            ...this.dadosLoginSession.fccTokenHeaders.headers,
            'Content-Type': 'multipart/form-data'
          }
        })
      }

      request
        .then(() => {
          this.$bvModal.hide('modal-edit' + this._uid)
          this.ListarImagens()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },

    ListarImagens() {
      const url = process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_GESTAO_PROJETOS

      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(url + 'Imagem/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listaImagens = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },

  mounted() {
    this.ListarImagens()
  }
}
</script>
